import { authHeader, handleResponse } from '../helpers';
export const RejectedUserRptService = {
    //fetchFeedbackData  
    fetchRejectedUserData 
};

function fetchRejectedUserData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}RejectedUserRpt/GetRejectedUserReport`, requestOptions)
        .then(handleResponse);
}